import React from 'react'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import MerchantFlowCard from '@nexidigital/merchantflowcard'
import './LegalRepPEPModal.scss'
import formattedMessage from './languageModule'
import PropTypes from 'prop-types'

const LegalRepPEPModal = (props) => (
  <Toggle>
    <MerchantModal
      title={formattedMessage.modalTitle}
      primaryButtonLabel={formattedMessage.modalPrimaryButtonLabel}
      primaryAction={() => props.actions.doHidePopup()}
      onClose={() => props.actions.doHidePopup()}
    >
      <div className='legalRepPEPModal'>
        <MerchantFlowCard title={formattedMessage.cardTitle1} accordion>
          <ul>
            <li>
              {formattedMessage.politicallyExposedText1}
            </li>
            <li>
              {formattedMessage.politicallyExposedText2}
            </li>
          </ul>
          <p>
            {formattedMessage.importantPublicOfficesQuestion}
          </p>
          <ul>
            {formattedMessage.importantPublicOfficesList.map((item, index) => (
              <li key={`important-office-${index}`}>
                {item}
              </li>
            ))}
          </ul>
        </MerchantFlowCard>
        <MerchantFlowCard title={formattedMessage.cardTitle2} accordion>
          <ul>
            {formattedMessage.notPoliticallyExposedList.map((item, index) => (
              <li key={`not-political-${index}`}>
                {item}
              </li>
            ))}
          </ul>
          <p>
            {formattedMessage.familyMemberQuestion}
          </p>
          <ul>
            {formattedMessage.familyMemberList.map((item, index) => (
              <li key={`family-member-${index}`}>
                {item}
              </li>
            ))}
          </ul>
          <p>
            {formattedMessage.notFamilyMemberText}
          </p>
          <p>
            {formattedMessage.closeRelationshipsQuestion}
          </p>
          <ul>
            {formattedMessage.closeRelationshipsList.map((item, index) => (
              <li key={`close-relationship-${index}`}>
                {item}
              </li>
            ))}
          </ul>
        </MerchantFlowCard>
      </div>
    </MerchantModal>
  </Toggle>
)

LegalRepPEPModal.propTypes = {
  actions: PropTypes.object
}

LegalRepPEPModal.defaultProps = {
  actions: {}
}

export default LegalRepPEPModal
